import { type RouterContextDataFragment } from '../api/fragments/RouterContextData';
import { type Maybe } from '../api/types';
import { useRouter } from '../components/contexts/RouterContextManager';
import BasicLayout from './BasicLayout';
import BasicProLayout from './BasicProLayout';
import EmptyLayout from './EmptyLayout';

const getLayoutComponent = (router: Maybe<RouterContextDataFragment>) => {
    if (!router?.layout) {
        return EmptyLayout;
    }

    switch (router.layout.__typename) {
        case 'BasicLayout':
            return BasicLayout;

        case 'BasicProLayout':
            return BasicProLayout;

        default:
            throw new Error('Layout type not supported');
    }
};

export type DynamicPortalLayoutProps = { children: JSX.Element };

const DynamicPortalLayout = ({ children }: DynamicPortalLayoutProps) => {
    const router = useRouter(false);
    const Layout = getLayoutComponent(router);

    return <Layout>{children}</Layout>;
};

export default DynamicPortalLayout;
